import _ from 'underscore';

const isDebug = false;
const logWarning = isDebug ? window.console.warn.bind(window.console) : _.noop;
const logInfo = isDebug ? window.console.info.bind(window.console) : _.noop;

/**
 * Overrides i18n's getString to map keys using the supplied key map.
 * NOTE: This only supports getString. All other i18n functions will
 * not be available on the returned object.
 * @param {Object} i18n - the actual i18n implementation
 * @param {Object<String, (String|Function)>} keyMap - the key map
 * The key map can map keys to two kinds of objects:
 * 1. String - in this case the original i18n will be called with the new string
 * 2. Function - in this case this function will be called with the original i18n and the key,
 * and its result returned from this function.
 * @return {Object} - a new object with one function - getString, which will do the mapping
 */
export function withKeyMap(i18n, keyMap) {
  const originalGetString = i18n.getString;

  return {
    getString(key, ...args) {
      let actualKey = key;

      if (_.has(keyMap, key)) {
        if (_.isFunction(keyMap[key])) {
          // the function is reponsible to get the translation
          const result = keyMap[key](i18n, key, ...args);
          const log = result ? logInfo : logWarning;

          log(`i18n requested key=${key}, dynamic mapping, resultingString=${result}`);
          return result;
        }

        actualKey = keyMap[key];
      }
      const result = originalGetString.call(i18n, `${actualKey}`, ...args);
      const log = result ? logInfo : logWarning;

      log(`i18n requested key=${key}, actualKey=${actualKey}, resultingString=${result}`);
      return result;
    },
  };
}
